import { css } from 'styled-components'
import { PhoneNumberFieldUiNewProps } from 'common/components/entities/Field/phone-number-field-ui'
import {
  backgroundColorCss,
  borderCss,
  mobileBackgroundColorCss,
  mobileBorderCss,
  mobilePaddingsCss,
  mobilePlaceholderColorCss,
  paddingsCss,
  placeholderColorCss,
  textAlignCss,
  mobileTextAlignCss,
  mobileBoxShadowCss,
  boxShadowCss,
  fontCss,
  mobileFontCss,
  lineHeightCss,
  mobileLineHeightCss,
} from 'common/utils/styleUtilsNew'

const getMobileStyles = () => css<PhoneNumberFieldUiNewProps>`
  ${mobileFontCss}
  ${mobileLineHeightCss}
  ${mobileTextAlignCss}
  ${mobilePaddingsCss}
  ${mobileBackgroundColorCss}
  ${mobileBorderCss}
  ${mobilePlaceholderColorCss}
  ${mobileBoxShadowCss}
  ${p =>
    p.mobilePlaceholderColor &&
    css`
      &::placeholder {
        color: ${p.mobilePlaceholderColor};
      }
    `}
  ${p =>
    p.mobileBorder &&
    !p.mobileBorder.style &&
    css`
         border-style: none;
        `}`

export const fieldStyles = () => css<PhoneNumberFieldUiNewProps>`
  width: 100%;
  font-size: 16px;
  padding: 12px 0;
  outline: none;
  text-indent: 10px;
  appearance: none;

  ${p =>
    p.hasIcon &&
    css`
      padding-right: ${(p.fontSize ?? 0) + 10}px;
    `};

  ${fontCss}
  ${lineHeightCss}
  ${textAlignCss}
  ${paddingsCss}
  ${backgroundColorCss}
  ${borderCss}
  ${placeholderColorCss}
  ${boxShadowCss}
  ${p =>
    p.hasErrors &&
    css`
      border-color: red;
    `}
  ${p =>
    p.placeholderColor &&
    css`
      &::placeholder {
        color: ${p.placeholderColor};
      }
    `}
  :disabled {
    opacity: 0.4;
  }

  ${p =>
    p.theme.isEditorMobileMode
      ? getMobileStyles()
      : css`
    ${p => p.theme.phone} {
      ${getMobileStyles()}
    }
  `}
`
